export default {
  MOVIE: 'MOVIE',
  SERIES: 'SERIES',
  CHANNEL: 'CHANNEL',
  CATCHUP: 'CATCHUP',
  TRAILER: 'TRAILER',
} as const;
